import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { BaseQueryFn, setupListeners } from '@reduxjs/toolkit/query'
import { Provider } from 'react-redux'

import pureChatReducer from './pure-chat.reducer'
import { PowerProAPIFactory, PowerProAPIProvider } from '~/service/powerpro'
import React from 'react'

export const reducerConfig = {
  chat: pureChatReducer,
}

const rootReducer = combineReducers(reducerConfig)
export type RootState = ReturnType<typeof rootReducer>

export function reset() {
  return {
    type: 'RESET',
    payload: null,
  }
}

const store = configureStore({
  reducer: (state, action) => {
    if (action.type === 'RESET') {
      // Reset to the initial store state.
      return rootReducer(undefined, action)
    }

    return rootReducer(state, action)
  },
})
export default store

export function StoreFactory(baseQuery?: BaseQueryFn, retryCount?: number) {
  const PP = PowerProAPIFactory(baseQuery, retryCount)

  const reducerConfig = {
    chat: pureChatReducer,
    [PP.reducerPath]: PP.reducer,
  }

  const rootReducer = combineReducers(reducerConfig)

  const s = configureStore({
    reducer: (state, action) => {
      if (action.type === 'RESET') {
        // Reset to the initial store state.
        return rootReducer(undefined, action)
      }

      return rootReducer(state, action)
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(PP.middleware),
  })
  // Enable `refetchOnFocus` / `refetchOnReconnect` support for queries that opt
  // in (e.g. the SGT guest-card query). Without this, those options are no-ops.
  setupListeners(s.dispatch)
  return {
    store: s,
    PowerProAPI: PP,
  }
}

export type Store = ReturnType<typeof StoreFactory>

export const StoreProvider = ({
  children,
  value: { store, PowerProAPI },
}: {
  children: React.ReactNode
  value: Store
}) => {
  return (
    <Provider store={store}>
      <PowerProAPIProvider value={PowerProAPI}>{children}</PowerProAPIProvider>
    </Provider>
  )
}
